import React from "react";
import MrclText from "../../marcel/MrclText";
import { usePerformance } from "../context/PerformanceContext";

interface SortableHeaderProps {
  label: React.ReactNode;
  sortOrder: "none" | "asc" | "desc";
  onSortChange: () => void;
  isDesktop: boolean;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  sortOrder,
  onSortChange,
  isDesktop,
}) => {
    const titleText = sortOrder === "asc"
      ? "Croissant"
      : sortOrder === "desc"
      ? "Décroissant"
      : "Cliquez pour trier";
    
      const {isCALive} = usePerformance();

    if(isCALive){
      return <MrclText>{label}</MrclText>;
    }

    return (
        <MrclText
        onClick={isDesktop ? onSortChange : undefined}
        title={titleText}
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
            cursor: isDesktop ? "pointer" : "default",
        }}
        >
        {label} 
        {isDesktop && (
            sortOrder === "none" ? (
            <MrclText
                style={{
                display: "inline-flex",
                flexDirection: "column",
                height: "16px",
                width: "16px",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
                pointerEvents: "none",
                }}
            >
                <MrclText style={{ display: "flex", height: "8px", alignItems: "center", position: "absolute", top: "0px" }}>
                <mrcl-icon-button
                    variant="transparent"
                    tone="neutral"
                    style={{ background: "none", color: "#005CA9", border: "none", padding: 0 }}
                    icon="chevron-up"
                />
                </MrclText>
                <MrclText style={{ display: "flex", height: "8px", alignItems: "center", position: "absolute", bottom: "0px" }}>
                <mrcl-icon-button
                    variant="transparent"
                    tone="neutral"
                    style={{ background: "none", color: "#005CA9", border: "none", padding: 0 }}
                    icon="chevron-down"
                />
                </MrclText>
            </MrclText>
            ) : (
            <mrcl-icon-button
                variant="transparent"
                tone="neutral"
                style={{ background: "none", color: "#005CA9", border: "none", padding: 0, margin: 0, cursor: "pointer" }}
                icon={sortOrder === "asc" ? "chevron-down" : "chevron-up"}
                onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onSortChange();
                }}
            />
            )
        )}
        </MrclText>
    );
};
